module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "sidebarb"
  }, [_c('p', {
    staticClass: "sidebartitle1"
  }, [_c('a', {
    attrs: {
      "id": "cat"
    }
  }), _vm._v("The Cat Lover’s Year")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/f0007-01.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("MONDAYS")]), _vm._v(" provide practical information, from welcoming a cat home to understanding his basic needs.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/f0007-02.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("TUESDAYS")]), _vm._v(" contain engaging tales of cats in history and in literature.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/f0007-03.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("WEDNESDAYS")]), _vm._v(" explore feline health and wellness topics, from acupuncture to the zodiac.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/f0007-04.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("THURSDAYS")]), _vm._v(" deliver ideas for cat-friendly home decor, crafts, and household tips for cat lovers.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/f0007-05.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("FRIDAYS")]), _vm._v(" introduce a world of cat breeds, from from Abyssinian to York Chocolate.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent2"
  }, [_c('img', {
    staticClass: "img",
    attrs: {
      "alt": "image",
      "src": "images/f0007-06.jpg"
    }
  }), _vm._v(" "), _c('strong', [_vm._v("WEEKENDS")]), _vm._v(" are reserved for bonding, relationship building, and planning special occasions with your pet.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15b43668","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/cat.vue
// module id = 72
// module chunks = 0